import script from "./HeroAgenda.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroAgenda.vue?vue&type=script&setup=true&lang=js"

import "./HeroAgenda.vue?vue&type=style&index=0&id=3c6b687f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.0_postcss@8.5.31_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c6b687f"]])

export default __exports__